import type { HeroTimeEntry } from "@/features/timesheetFlow/timesheetFlowApi";
import { api } from "@/lib/apiClient";
import type { BookedHoursRow, BookedHoursSource } from "@/lib/bookedHours";

export interface StundenUmbuchungEntry {
  source: BookedHoursSource;
  key: string;
}

export interface StundenUmbuchungResult {
  from_auftrag_id: number;
  to_auftrag_id: number;
  moved_count: number;
  hours_decimal: number;
  source_note_id: number | null;
  target_note_id: number | null;
}

type HeroTimeLike = {
  uuid?: string;
  _uuid?: string;
  hero_uuid?: string;
};

export function bookedHoursRebookEntry(row: BookedHoursRow): StundenUmbuchungEntry {
  if (row.source === "hero") {
    return { source: "hero", key: row.id.startsWith("hero:") ? row.id.slice("hero:".length) : row.id };
  }
  if (row.source === "subcontractor") {
    return {
      source: "subcontractor",
      key: row.id.startsWith("sub:") ? row.id.slice("sub:".length) : row.id,
    };
  }
  return {
    source: "employee",
    key: row.id.startsWith("emp:") ? row.id.slice("emp:".length) : row.id,
  };
}

function heroTimeId(item: HeroTimeLike): string {
  return String(item._uuid || item.uuid || item.hero_uuid || "").trim();
}

/** Hängt übernommene Hero-Zeiten an, ohne eine UUID doppelt zu zählen. */
export function mergeHeroTimeItems<T extends HeroTimeLike>(primary: T[], extra: T[]): T[] {
  const seen = new Set(primary.map(heroTimeId).filter(Boolean));
  const merged = [...primary];
  for (const item of extra) {
    const id = heroTimeId(item);
    if (id && seen.has(id)) continue;
    merged.push(item);
    if (id) seen.add(id);
  }
  return merged;
}

export async function listHeroStundenZuordnung(auftragId: number): Promise<HeroTimeEntry[]> {
  try {
    const data = await api.get<HeroTimeEntry[]>(
      `/auftraege/${encodeURIComponent(String(auftragId))}/hero-stunden-zuordnung`,
    );
    return Array.isArray(data) ? data : [];
  } catch (err) {
    console.warn("[stundenUmbuchung] Hero-Umbuchungen laden fehlgeschlagen:", err);
    return [];
  }
}

export async function rebookProjectHours(
  auftragId: number,
  payload: {
    ziel_auftrag_id: number;
    begruendung: string;
    entries: StundenUmbuchungEntry[];
  },
): Promise<StundenUmbuchungResult> {
  return api.post<StundenUmbuchungResult>(
    `/auftraege/${encodeURIComponent(String(auftragId))}/stunden-umbuchung`,
    payload,
  );
}
